import { PREFIX_IDENTITY_PATH, PREFIX_RETX_PATH } from "../constant/path";

export const USER_API = {
  urlRegister: `${PREFIX_IDENTITY_PATH}/users/register`,
  urlRegisterBusiness: `${PREFIX_IDENTITY_PATH}/business-users/register`,
  urlRefreshToken: `${PREFIX_IDENTITY_PATH}/users/refresh_token`,
  urlValidateUser: `${PREFIX_IDENTITY_PATH}/users/register/validate`,
  urlCheckExistedUser: `${PREFIX_IDENTITY_PATH}/users/register/checkExisted`,
  urlCheckExistedBusiness: `${PREFIX_IDENTITY_PATH}/business-users/register/checkExisted`,
  urlValidateBusiness: `${PREFIX_IDENTITY_PATH}/business-users/register/validate`,

  urlVerifyPassword: `${PREFIX_IDENTITY_PATH}/users/info/verify_password`,
  urlForgotPassword: `${PREFIX_IDENTITY_PATH}/users/forgot_password`,
  urlUpdatePassword: `${PREFIX_IDENTITY_PATH}/users/info/password`,
  urlAddPassword: `${PREFIX_IDENTITY_PATH}/users/info/add_password`,
  urlCheckPasswordExisted: `${PREFIX_IDENTITY_PATH}/users/info/check_password_existed`,

  urlUpdateAvatar: `${PREFIX_IDENTITY_PATH}/users/avatar`,
  urlUpdateAddress: `${PREFIX_IDENTITY_PATH}/users/user_address`,

  urlUpdateWallet: `${PREFIX_IDENTITY_PATH}/users/info/wallet`,
  urlGetInfoUserByWallet: (walletAddress: string) =>
    `${PREFIX_IDENTITY_PATH}/users/wallet_address/${walletAddress}`,
  getSystemUserByWallet: (walletAddress: string) =>
    `${PREFIX_IDENTITY_PATH}/system_users/wallet_address/${walletAddress}`,
  urlCheckWalletExisted: (walletAddress: string) =>
    `${PREFIX_IDENTITY_PATH}/users/check_wallet/${walletAddress}`,

  urlUpdatePhoneNumber: `${PREFIX_IDENTITY_PATH}/users/info/phone_number`,
  urlUpdateGlobalPhoneNumber: `${PREFIX_IDENTITY_PATH}/users/info/global_phone_number`,
  urlUpdateEmail: `${PREFIX_IDENTITY_PATH}/users/info/email`,

  urlAddNewPhone: `${PREFIX_IDENTITY_PATH}/users/info/add_phone_number`,
  urlAddNewGlobalPhone: `${PREFIX_IDENTITY_PATH}/users/info/add_global_phone_number`,
  urlAddNewEmail: `${PREFIX_IDENTITY_PATH}/users/info/add_email`,

  urlIsExistUsername: (username: string) =>
    `${PREFIX_RETX_PATH}/users/is-exist-username/${username}`,

  urlGetBalanceHistory: `${PREFIX_RETX_PATH}/users/balance_history`,
  urlGetBiddingAsset: `${PREFIX_RETX_PATH}/users/collection_asset/bidding`,

  urlPrivateKey: `${PREFIX_IDENTITY_PATH}/system_users/info/key`,
  urlMnemonicHash: `${PREFIX_IDENTITY_PATH}/system_users/info/mnemonic`,
  urlCheckKeyHash: `${PREFIX_IDENTITY_PATH}/system_users/info/key_hash`,
  urlGetUserByKeyword: `${PREFIX_IDENTITY_PATH}/users/search`,

  urlUpdateWebsiteProfile: `${PREFIX_IDENTITY_PATH}/users/website`,
  urlUpdateAddressProfile: `${PREFIX_IDENTITY_PATH}/users/user_address`,
  urlUpdateProfile: `${PREFIX_IDENTITY_PATH}/users/user_profile`,

  urlGetNonce: `${PREFIX_IDENTITY_PATH}/users/siwe/nonce`,
  urlVerifyMessage: `${PREFIX_IDENTITY_PATH}/users/siwe/verify`,
};
